import patterns from '@/config/validation/patterns'

export function validateEmail (value) {
  if (value && value.length > 0) {
    const pattern = patterns.email
    return value === '' || pattern.test(value)
  } else {
    return true
  }
}

export function validatePhoneNumber (value) {
  if (value && value.length > 0) {
    const pattern = patterns.phoneNumber
    return value === '' || pattern.test(value)
  } else {
    return true
  }
}